module.exports = __webpack_public_path__ + "static/media/br-pr.df6b86c5.svg";